export default __webpack_public_path__ + "38f10e503a7a5a1295da3af073521607.png";